"use strict";var extend = require("raptor-util/extend");
var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VDocumentFragmentClone(other) {
  extend(this, other);
  this.cb_ = null;
  this.cc_ = null;
}

function VDocumentFragment(out) {
  this.bY_(null /* childCount */);
  this.r_ = out;
}

VDocumentFragment.prototype = {
  c__: 11,

  cd_: true,

  bS_: function () {
    return new VDocumentFragmentClone(this);
  },

  br_: function (host) {
    return (host.ownerDocument || host).createDocumentFragment();
  }
};

inherit(VDocumentFragment, VNode);

VDocumentFragmentClone.prototype = VDocumentFragment.prototype;

module.exports = VDocumentFragment;